import { defineMessages } from '@jutro/locale';

export default defineMessages({
    pageHeader: {
        id: 'ml.policyChange.pa.additionalInfoToPurchase.pageHeader',
        defaultMessage: 'We\'re almost done! Just a few more questions'
    },
    additionalDetailsHeader: {
        id: 'ml.policyChange.pa.additionalInfoToPurchase.Additional Details',
        defaultMessage: 'Additional Details'
    },
    financeCategoryHelpTextTitleMap: {
        id: 'ml.policyChange.pa.additionalInfoToPurchase.financeCategoryHelpTextTitleMap',
        defaultMessage: 'What is non-owned?'
    },
    financeCategoryHelpTextMap: {
        id: 'ml.policyChange.pa.additionalInfoToPurchase.financeCategoryHelpTextMap',
        defaultMessage: 'This vehicle is not owned by the insured but has been provided for their regular use.'
    },
    spouseEmailValidationMsg: {
        id: 'ml.policyChange.pa.additionalInfoToPurchase.spouseEmailValidationMsg',
        defaultMessage: 'Each customer must have a unique email address.'
    },
    verifyingVins: {
        id: 'ml.policyChange.pa.additionalInfoToPurchase.Verifying VINs',
        defaultMessage: 'Verifying VIN\'s'
    },
    vehicleX: {
        id: 'ml.policyChange.pa.additionalInfoToPurchase.vehicleX',
        defaultMessage: 'Vehicle #{vehicleNumber}'
    },
    driverX: {
        id: 'ml.policyChange.pa.additionalInfoToPurchase.driverX',
        defaultMessage: 'Driver #{driverNumber}'
    },
    excludedDriverX: {
        id: 'ml.policyChange.pa.additionalInfoToPurchase.excludedDriverX',
        defaultMessage: 'Excluded Driver #{driverNumber}'
    },
    vinDesc: {
        id: 'ml.policyChange.pa.additionalInfoToPurchase.vinDesc',
        defaultMessage: 'VIN required. Must be 17 digits if 1981 and newer.'
    },
    serialNumber: {
        id: 'ml.policyChange.pa.additionalInfoToPurchase.Serial Number',
        defaultMessage: 'Serial Number'
    },
    enterSerialNumber: {
        id: 'ml.policyChange.pa.additionalInfoToPurchase.Enter Serial Number',
        defaultMessage: 'Enter Serial Number'
    },
    vehOwnedFinancedLeased: {
        id: 'ml.policyChange.pa.additionalInfoToPurchase.Is this vehicle owned, financed or leased',
        defaultMessage: 'Is this vehicle owned, financed or leased?'
    },
    leased: {
        id: 'ml.policyChange.pa.additionalInfoToPurchase.leased',
        defaultMessage: 'Leased'
    },
    financed: {
        id: 'ml.policyChange.pa.additionalInfoToPurchase.financed',
        defaultMessage: 'Financed'
    },
    owned: {
        id: 'ml.policyChange.pa.additionalInfoToPurchase.owned',
        defaultMessage: 'Owned'
    },
    nonOwned: {
        id: 'ml.policyChange.pa.additionalInfoToPurchase.nonOwned',
        defaultMessage: 'Non-owned'
    },
    driverLicense: {
        id: 'ml.policyChange.pa.additionalInfoToPurchase.Driver License',
        defaultMessage: 'Driver\'s License'
    },
    stateLicensed: {
        id: 'ml.policyChange.pa.additionalInfoToPurchase.State Licensed',
        defaultMessage: 'State Licensed'
    },
    licenseStateTooltipTitle: {
        id: 'ml.policyChange.pa.additionalInfoToPurchase.licenseStateTooltipTitle',
        defaultMessage: 'What if I don\'t have a US license?'
    },
    licenseStateTooltip: {
        id: 'ml.policyChange.pa.additionalInfoToPurchase.licenseStateTooltip',
        defaultMessage: 'Select DC, Canada, US Territories or Foreign as your state licensed.'
    },
    ageFirstLicensed: {
        id: 'ml.policyChange.pa.additionalInfoToPurchase.Age First Licensed',
        defaultMessage: 'Age First Licensed'
    },
    financialResponsibilityProof: {
        id: 'ml.policyChange.pa.additionalInfoToPurchase.financialResponsibilityProof',
        defaultMessage: 'Requires proof of financial responsibility (SR22/FR44/FR19/FS1)?'
    },
    requiresProofTooltipTitle: {
        id: 'ml.policyChange.pa.additionalInfoToPurchase.requiresProofTooltipTitle',
        defaultMessage: 'What is this?'
    },
    requiresProofTooltip: {
        id: 'ml.policyChange.pa.additionalInfoToPurchase.requiresProofTooltip',
        defaultMessage: 'Proof of Financial Responsibility is a state-mandated document that certifies that the liability insurance purchased meets the minimum required limits of coverage for the state. The certificate (SR22, FR44, FR19 or FS1) is filed with your state\'s Department of Motor Vehicles by your auto insurance carrier. Select this if you have a Proof of Financial Responsibility certification with your current carrier or if your state DMV or a court order requires you to have the certification. We do not charge a fee to file the certificate.'
    },
    stateRequesting: {
        id: 'ml.policyChange.pa.additionalInfoToPurchase.State Requesting',
        defaultMessage: 'State Requesting'
    },
    reasonRequired: {
        id: 'ml.policyChange.pa.additionalInfoToPurchase.Reason Required',
        defaultMessage: 'Reason Required'
    },
    certEffDate: {
        id: 'ml.policyChange.pa.additionalInfoToPurchase.Certificate Effective Date',
        defaultMessage: 'Certificate Effective Date'
    },
    caseNumber: {
        id: 'ml.policyChange.pa.additionalInfoToPurchase.Case Number',
        defaultMessage: 'Case Number'
    },
    emailAddress: {
        id: 'ml.policyChange.pa.additionalInfoToPurchase.Email Address',
        defaultMessage: 'Email Address'
    },
    spouseEmailAddress: {
        id: 'ml.policyChange.pa.additionalInfoToPurchase.Spouse\'s Email Address',
        defaultMessage: 'Spouse\'s Email Address'
    },
    continueWithYourChange: {
        id: 'ml.policyChange.pa.additionalInfoToPurchase.continue with your change',
        defaultMessage: 'continue with your change'
    },
    nextDesc: {
        id: 'ml.policyChange.pa.additionalInfoToPurchase.nextDesc',
        defaultMessage: 'We\'ll {continueWithYourChange} next'
    },
    removeLeaseLoanGap: {
        id: 'ml.policyChange.pa.additionalInfoToPurchase.removeLeaseLoanGap',
        defaultMessage: 'Unable to change from Financed as vehicle includes Lease Loan Gap coverage. Remove Lease Loan Gap coverage to continue.'
    },
    updateFieldOrAddInterestedParty: {
        id: 'ml.policyChange.pa.additionalInfoToPurchase.updateFieldOrAddInterestedParty',
        defaultMessage: 'Please update Owned/Financed/Leased field or add Interested Party Information.'
    },
    updateOwnedFinanceLeasedField: {
        id: 'ml.policyChange.pa.additionalInfoToPurchase.updateOwnedFinanceLeasedField',
        defaultMessage: 'Please update Owned/Financed/Leased field as Interested Party Information was added.'
    }
});
